import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'vernost-progress',
    template: `
        <mat-progress-bar
        [color]="color"
        [mode]="mode"
        [value]="value"
        [bufferValue]="bufferValue">
        </mat-progress-bar>
  `
})

export class VernostProgressBarComponent {

    color = 'primary';
    mode = 'indeterminate';
    value:number = 50;
    bufferValue = 75;

    constructor() {

    }

    ngOnInit() {

    }
}
